import usedBanksActions from './actions';
import { UsedBanksState } from './types';
import { createSlice } from '@reduxjs/toolkit';

const initialState: UsedBanksState = {
  usedBanks: [],
  usedBanksError: null,
  usedBanksLoading: false,
  usedBanksIsEmpty: false,
};

export const usedBanksSlice = createSlice({
  initialState,
  name: 'usedBanks',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(usedBanksActions.getUsedBanks.pending, (state) => {
      state.usedBanksLoading = true;
    });

    builder.addCase(usedBanksActions.getUsedBanks.fulfilled, (state, { payload: { usedBanks } }) => {
      state.usedBanksError = null;
      state.usedBanks = usedBanks;
      state.usedBanksLoading = false;
      state.usedBanksIsEmpty = !!!usedBanks.length;
    });

    builder.addCase(usedBanksActions.getUsedBanks.rejected, (state, { error }) => {
      state.usedBanksLoading = false;
      state.usedBanksError = error;
    });
  },
});

export default usedBanksSlice.reducer;
